import ServiceCRUD from '../../../../../services/ServiceCRUDFLEXUC';

class Service extends ServiceCRUD {
  constructor() {
    super('/api/usuarios');
  }
}

export default new Service();
